import { CrmProjectConfigType } from '@/types/crm'
import { CrmWithConfiguration } from '@/types/crm/crm'
import { CrmProjectWithConfiguration } from '@/types/crm/crm_project'
import { Session } from '@supabase/supabase-js'
import { create } from 'zustand'
import { Database } from '../supabase/supabase_types'
import { FullProject } from '../supabase/types'
import { UseGetOrganizationByIdReturnData } from '../../features/organization/hooks/useQuery/useGetOrganizationById'
import { UseProjectsListReturnData } from '../useQuery/project/useProjectsList'
import { useGetSurveyByIdReturnData } from '../useQuery/survey/useGetSurveyById'

export type storeUser = {
  first_name: string | null,
  last_name: string | null,
  id: string | null,
  session: Session | null,
  email: string | null,
}

export type userStoreMethods = {
  login: (user: storeUser) => void,
  logout: () => void,
  setSession: (session: Session | null) => void,
}

export type userStore = userStoreMethods & storeUser

const user: storeUser = {
  first_name: null,
  last_name: null,
  id: null,
  session: null,
  email: null,
}

export const useUserStore = create<userStore>((set) => ({
  ...user,
  login: (user: storeUser) => set(() => ({
    ...user
  })),
  logout: () => set({ ...user }),
  setSession: (session: Session | null) => set((state) => ({
    ...state,
    session,
    ...session?.user
  })),
}))



type projectStore = {
  project: UseProjectsListReturnData[0] | null,
  setProject: (project: UseProjectsListReturnData[0] | null) => void,
}

export const useProjectStore = create<projectStore>((set) => ({
  project: null,
  setProject: (project) => set(() => ({
    project
  })),
}))



type organizationStore = {
  organization: UseGetOrganizationByIdReturnData | null,
  setOrganization: (organization: UseGetOrganizationByIdReturnData | null) => void,
}

export const useOrganizationStore = create<organizationStore>((set) => ({
  organization: null,
  setOrganization: (organization) => set(() => ({
    organization
  })),
}))


type surveyStore = {
  survey: useGetSurveyByIdReturnData | null,
  setSurvey: (survey: useGetSurveyByIdReturnData | null) => void,
}

export const useSurveyStore = create<surveyStore>((set) => ({
  survey: null,
  setSurvey: (survey) => set(() => ({
    survey
  })),
}))

type crmWithConfigs = Database['public']['Tables']['crm']['Row'] & {
  crm_config: Database['public']['Tables']['crm_config']['Row'][],
}

type crmStore = {
  crm: crmWithConfigs | null,
  crmConfig: Database['public']['Tables']['crm_config']['Row'] | null,
  // crmProject: Database['public']['Tables']['crm_project']['Row'] & {
  //   crm: Database['public']['Tables']['crm']['Row'] | null
  // } | null,
  crmProject: CrmProjectWithConfiguration & {
    crm: CrmWithConfiguration | null
  } | null,
  crmProjectConfig: CrmProjectConfigType | null,
  setCrm: (crm: crmWithConfigs) => void,
  setCrmConfig: (crmConfig: Database['public']['Tables']['crm_config']['Row']) => void,
  setCrmProject: (crmProject: CrmProjectWithConfiguration & {
    crm: CrmWithConfiguration | null
  } | null) => void,
  setCrmProjectConfig: (crmProjectConfig: CrmProjectConfigType) => void,
}

export const useCrmStore = create<crmStore>((set) => ({
  crm: null,
  crmConfig: null,
  crmProject: null,
  crmProjectConfig: null,
  setCrm: (crm) => set(() => ({
    crm
  })),
  setCrmConfig: (crmConfig) => set(() => ({
    crmConfig
  })),
  setCrmProject: (crmProject) => set(() => ({
    crmProject
  })),
  setCrmProjectConfig: (crmProjectConfig) => set(() => ({
    crmProjectConfig
  })),
}))

type crmProjectStore = {
  crmProject: Database['public']['Tables']['crm_project']['Row'] | null,
  setCrmProject: (crmProject: Database['public']['Tables']['crm_project']['Row']) => void,
}

export const useCrmProjectStore = create<crmProjectStore>((set) => ({
  crmProject: null,
  setCrmProject: (crmProject) => set(() => ({
    crmProject
  })),
}))


type projectsStore = {
  projects: FullProject[],
  setProjects: (projects: FullProject[]) => void,
  addProject: (project: FullProject) => void,
}

export const useProjectsStore = create<projectsStore>((set) => ({
  projects: [],
  setProjects: (projects) => set(() => ({
    projects,
  })),
  addProject: (project) => {
    set((state) => {
      return ({ projects: [...state.projects, project] })
    })
  },
}))

